import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Take } from '@sc/types';

@Component({
  selector: 'sc-recordings',
  templateUrl: './recordings.component.html',
  styleUrls: ['./recordings.component.scss'],
})
export class RecordingsComponent implements OnInit {
  @Output() closeSidebar = new EventEmitter<boolean>();
  selectedTakeID: string;

  constructor() {}

  ngOnInit() {}

  /**
   * Sets the currently selected take
   */
  setSelected(takeID: string) {
    this.selectedTakeID = takeID;
  }
}
